// extracted by mini-css-extract-plugin
module.exports = {"form":"AuthForm_form__1_HpH"};